export const b2bArbitrageCreateTranslations = {
  steps: {
    funds: 'Supports',
    confirmation: 'Confirmation',
  },
  actions: {
    success: 'Arbitrage demandé : il est créé une fois approuvé par un autre opérateur',
    failure: "Échec de la demande d'arbitrage : %{error}",
    full_position: 'Position complète',
    add_allocation: 'Ajouter un support',
  },
  sections: {
    sources: 'Supports à vendre',
    targets: 'Supports à acheter',
    summary_confirmation: 'Récapitulatif et confirmation',
    confirmations: 'Confirmations',
    confirm_accuracy: "Je confirme l'exactitude des données.",
  },
  fields: {
    saving_plan_id: 'Plan',
    instrument: 'Support',
    amount: 'Montant (€)',
    held: 'Détenu : %{amount}',
    total_sold: 'Total vendu',
    total_bought: 'Total acheté',
    notify_employee: 'Notifier le salarié',
    reason: 'Motif',
  },
  messages: {
    no_holdings: 'Aucune position détenue sur ce plan',
    amounts_do_not_match: 'Le total vendu doit être égal au total acheté.',
    managed_plan: "Géré par l'allocation du plan",
    notify_employee_help:
      "Une fois l'arbitrage approuvé, le salarié reçoit les e-mails d'arbitrage enregistré et exécuté, indiquant que l'équipe des opérations a effectué cette modification.",
  },
  errors: {
    explore_has_restrictions:
      'Une restriction bloque cet arbitrage : le salarié est restreint sur ce produit, un support à vendre est totalement restreint, ou un support à acheter est restreint pour les supports vendus choisis ou globalement.',
    explore_mixed_tax_wrappers:
      "Tous les plans d'un arbitrage doivent avoir la même enveloppe fiscale : les plans PEE et PERECO ne peuvent pas être mélangés.",
    explore_duplicate_instrument_allocation:
      "Un support ne peut apparaître qu'une fois parmi les supports à vendre et une fois parmi les supports à acheter, et ne peut pas être vendu et acheté sur le même plan.",
    explore_instrument_locked_for_plan: 'Un support à vendre est bloqué dans son plan.',
    explore_instrument_not_enabled_for_plan:
      "Un support à acheter n'est pas activé dans le plan cible.",
    explore_insufficient_shares: 'Un montant à vendre dépasse ce que le salarié détient.',
    explore_amount_exceeds_vested: 'Un montant à vendre dépasse le montant disponible.',
    explore_below_minimum_order:
      "Un montant est inférieur au minimum : 10 €, sauf s'il solde la position ou s'il s'agit du seul achat.",
    explore_too_many_allocations:
      'En dessous de 10 €, le montant ne peut être investi que sur un seul support.',
    explore_amounts_do_not_match: 'Le total vendu doit être égal au total acheté.',
    explore_multiple_pilote_allocation:
      "Un plan piloté ne peut être utilisé qu'une seule fois par arbitrage : en vente ou en achat, pas les deux, ni plusieurs.",
  },
  validation: {
    exceeds_position: 'Le montant dépasse la position (%{max}).',
    below_minimum: "Minimum %{min}, sauf pour solder la position ou s'il s'agit du seul achat.",
  },
};
